const ENTerms = {
	"Alterar termos de aceitação" : "Change terms of acceptance",
	"Cadastro de termos de aceitação" : "Registration of acceptance terms",
	"Deseja realmente excluir o termo de uso" : "Do you really want to delete the acceptance term",
	"Erro ao aceitar os termos de uso": "Error accepting terms of use",
	"Erro ao adicionar termo de uso" : "Error adding term of use",
	"Erro ao alterar termo de uso" : "Error on changing term of use",
	"Erro ao carregar termo de uso" : "Error on loading term of use",
	"Erro ao excluir termo de uso" : "Error on deleting term of use",
	"Eu li e concordo com os termos de uso": "I have read and agree to the terms of use",
	"Exclusão de termo de uso" : "Delete term of use",
	"Excluir seção":"Delete section",
	"Novo termo de aceitação" : "Insert term of use",
	"Não há nenhuma seção para este termo de aceitação" : "There is no section for this term of acceptance",
	"Nova seção" : "New section",
	"Seção" : "Section",
	"Seções" : "Sections",
	"Propriedades" : "Properties",
	"Termos de Aceitação" : "Acceptance Terms",
	"Tipo termo" : "Term type",
	"Termo de uso adicionado com sucesso" : "Term of use successfully added",
	"Termo de uso adicionado alterado com sucesso" : "Term of use successfully changed",
	"Termo de uso excluído com sucesso" : "Term of use successfully deleted",
	"Termo de uso" : "Term of use",
	"Vigência" : "Validity",
	"Você tem que marcar a opção concordando com os termos de uso": "You have to check the option agreeing to the terms of use"
};

export default ENTerms;

